<template>
  <v-btn
    width="100%"
    :color="value?'red lighten-1':''"
    @mouseleave="value = false"
    @click="
      value?
      $emit('clickDelete')
      :
      value = true
      "
    >
    <template v-if="!value">
      <slot/>
    </template>
    <template v-else>
      <v-icon>delete</v-icon>
      <div class="user-select-none">{{confirm_text?confirm_text:$t('Buttons.Delete')}}</div>
    </template>
  </v-btn>
</template>
<script>
  export default {
    props: ['confirm_text'],
    data: () => ({
      value: false,
    }),
  }
</script>
<style>
</style>
